import { api } from "./dataService";

export const fetchMappingProfiles = async (params = {}) => {
  const query = new URLSearchParams();
  if (params.connector_id) query.append("connector_id", params.connector_id);
  if (params.record_type) query.append("record_type", params.record_type);
  const qs = query.toString();
  return (await api.get(`data/import-mapping-profiles${qs ? "?" + qs : ""}`))
    .data;
};

export const fetchMappingProfile = async (profile_id) => {
  return (await api.get(`data/import-mapping-profiles/${profile_id}`)).data;
};

export const createMappingProfile = async (payload) => {
  return (await api.post("data/import-mapping-profiles", payload)).data;
};

export const updateMappingProfile = async (profile_id, payload) => {
  return (
    await api.patch(`data/import-mapping-profiles/${profile_id}`, payload)
  ).data;
};

export const deleteMappingProfile = async (profile_id) => {
  await api.delete(`data/import-mapping-profiles/${profile_id}`);
};

export const fetchEntityFields = async (record_type) => {
  return (await api.get(`data/import-entities/${record_type}/fields`)).data;
};

export const fetchConnectors = async () => {
  return (await api.get("data/import-connectors")).data;
};
